function createOptimizedView(children, viewProps, baseViews) {}
export { createOptimizedView };
//# sourceMappingURL=createOptimizedView.mjs.map
